/**
 * PDP behavior — parity με το live selectCallback (annex-js §5/halo.js):
 * variant resolve από swatch-pills (radios — live: ζωγραφισμένα κουμπιά) →
 * τιμή/compare/SKU/κουμπί/εικόνα/history state + swatch-header selected value·
 * «Αγορά τώρα» = instantBuy parity (serialize form → POST /cart/add →
 * redirect /checkout — script3647 συμπεριφορά)· thumbs· fullscreen lightbox
 * (live: fancybox data-fancybox="images")· ask-expert dialog.
 * Tabs = native <details> accordion — δεν χρειάζονται JS.
 */
(function () {
  var root = document.querySelector('[data-product]');
  if (!root) return;

  var variants = [];
  try {
    variants = JSON.parse(document.querySelector('[data-product-json]').textContent);
  } catch (e) { /* no variants island */ }

  var form = root.querySelector('form[action*="/cart/add"]');
  var idInput = root.querySelector('[data-variant-id]');
  var priceEl = root.querySelector('[data-price]');
  var compareEl = root.querySelector('[data-compare-price]');
  var skuEl = root.querySelector('[data-sku]');
  var atcBtn = root.querySelector('[data-atc-button]');

  function formatMoney(cents) {
    // EUR μονό νόμισμα (live: enable_auto_currency=false) — €X,XXX.XX όπως το money_format
    var n = (cents / 100).toFixed(2);
    var parts = n.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '€' + parts[0] + '.' + parts[1];
  }

  function currentSelection() {
    var opts = [];
    root.querySelectorAll('[data-option-radio]:checked').forEach(function (r) {
      opts[parseInt(r.getAttribute('data-option-index'), 10)] = r.value;
    });
    return opts;
  }

  function resolveVariant() {
    var sel = currentSelection();
    return variants.find(function (v) {
      return v.options.every(function (o, i) { return o === sel[i]; });
    });
  }

  var mqMobileGallery = window.matchMedia('(max-width: 991px)');
  function switchMedia(mediaId) {
    if (!mediaId) return;
    root.querySelectorAll('[data-media-item]').forEach(function (m) {
      m.classList.toggle('is-active', m.getAttribute('data-media-id') === String(mediaId));
    });
    root.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.classList.toggle('is-active', t.getAttribute('data-media-id') === String(mediaId));
    });
    // F3: στο mobile-strip το switch = scroll στο slide (thumbs/variant image)
    if (mqMobileGallery.matches) {
      var strip = root.querySelector('[data-main-media]');
      var target = strip && strip.querySelector('[data-media-item][data-media-id="' + String(mediaId) + '"]');
      if (strip && target) strip.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
    }
  }

  function updateSwatchHeaders() {
    root.querySelectorAll('[data-swatch]').forEach(function (sw) {
      var checked = sw.querySelector('[data-option-radio]:checked');
      var out = sw.querySelector('[data-selected-value]');
      if (checked && out) out.textContent = checked.value;
    });
  }

  function onVariantChange() {
    updateSwatchHeaders();
    var v = resolveVariant();
    if (!v) {
      if (atcBtn) { atcBtn.disabled = true; atcBtn.textContent = 'Μη διαθέσιμο'; }
      return;
    }
    idInput.value = v.id;
    if (priceEl) priceEl.textContent = formatMoney(v.price);
    if (compareEl) {
      if (v.compare_at_price && v.compare_at_price > v.price) {
        compareEl.hidden = false;
        compareEl.textContent = formatMoney(v.compare_at_price);
        if (priceEl) priceEl.classList.add('on-sale');
      } else {
        compareEl.hidden = true;
        if (priceEl) priceEl.classList.remove('on-sale');
      }
    }
    if (skuEl) skuEl.textContent = v.sku || '';
    if (atcBtn) {
      atcBtn.disabled = !v.available;
      // F3-finding-9 owner-ruled: ΠΑΝΤΑ «Στο Καλάθι» — ποτέ «Προπαραγγελία»
      if (!v.available) atcBtn.textContent = 'Εξαντλημένο';
      else atcBtn.textContent = 'Στο Καλάθι';
    }
    // F3: buy-now κρύβεται τελείως σε εξαντλημένο variant (owner + live-parity)
    var buyNowBtn = root.querySelector('[data-buy-now]');
    if (buyNowBtn) buyNowBtn.hidden = !v.available;
    if (v.featured_media) switchMedia(v.featured_media.id);
    // history state parity (?variant=)
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    } catch (e) { /* noop */ }
  }

  root.querySelectorAll('[data-option-radio]').forEach(function (r) {
    r.addEventListener('change', onVariantChange);
  });

  // Thumbs
  root.querySelectorAll('[data-thumb]').forEach(function (t) {
    t.addEventListener('click', function () { switchMedia(t.getAttribute('data-media-id')); });
  });

  // F3 owner (v2): mobile gallery = native scroll-snap strip (CSS) — εδώ μόνο
  // sync: καθώς ο χρήστης σέρνει, ενημερώνονται is-active/thumbs (χωρίς νέο scroll)
  var mainMediaBox = root.querySelector('[data-main-media]');

  /* Β.9-video ΟΡΙΣΤΙΚΟ Σ07-16 (owner): κλειδωμένο κάδρο 3:4 = καθαρό CSS (καμία
     JS-γεωμετρία)· εδώ μόνο η ένδειξη fullscreen του βίντεο (mobile) */
  root.querySelectorAll('[data-video-fs]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var wrap = btn.closest('[data-video-wrap]');
      var v = wrap && wrap.querySelector('video');
      if (!v) return;
      if (v.webkitEnterFullscreen) v.webkitEnterFullscreen(); /* iOS native player */
      else if (v.requestFullscreen) v.requestFullscreen();
      if (v.paused) { try { v.play(); } catch (e) { /* noop */ } }
    });
  });

  if (mainMediaBox) {
    var stripTimer = null;
    mainMediaBox.addEventListener('scroll', function () {
      if (!mqMobileGallery.matches) return;
      clearTimeout(stripTimer);
      stripTimer = setTimeout(function () {
        var items = Array.prototype.slice.call(root.querySelectorAll('[data-media-item]'));
        if (items.length < 2) return;
        var idx = Math.round(mainMediaBox.scrollLeft / mainMediaBox.clientWidth);
        idx = Math.max(0, Math.min(items.length - 1, idx));
        var it = items[idx];
        if (it && !it.classList.contains('is-active')) {
          items.forEach(function (m) { m.classList.toggle('is-active', m === it); });
          root.querySelectorAll('[data-thumb]').forEach(function (t) {
            t.classList.toggle('is-active', t.getAttribute('data-media-id') === it.getAttribute('data-media-id'));
          });
          // βίντεο που φεύγει από το κάδρο = pause
          items.forEach(function (m) {
            if (m !== it) { var v = m.querySelector('video'); if (v && !v.paused) v.pause(); }
          });
        }
      }, 90);
    }, { passive: true });
  }

  // Fullscreen lightbox (live: κλικ στη φωτο = fancybox fullscreen)
  var lightbox = document.querySelector('[data-lightbox]');
  if (lightbox) {
    var lbItems = Array.prototype.slice.call(lightbox.querySelectorAll('[data-lightbox-item]'));
    var counter = lightbox.querySelector('[data-lightbox-counter]');
    var currentIdx = 0;
    function pauseLightboxMedia(item) {
      var v = item.querySelector('video');
      if (v && !v.paused) v.pause();
      // external_video (YouTube/Vimeo iframe): reload σταματά το playback χωρίς vendor API
      var f = item.querySelector('iframe');
      if (f) f.src = f.src;
    }
    function showLightboxItem(i) {
      if (!lbItems.length) return;
      currentIdx = (i + lbItems.length) % lbItems.length;
      lbItems.forEach(function (item, j) {
        item.hidden = j !== currentIdx;
        if (item.hidden) { pauseLightboxMedia(item); return; }
        // hidden+lazy δεν κατεβαίνει ποτέ — eager στην τρέχουσα
        if (item.tagName === 'IMG') item.loading = 'eager';
      });
      // προφόρτωση γειτονικών εικόνων
      [currentIdx + 1, currentIdx - 1].forEach(function (n) {
        var nb = lbItems[(n + lbItems.length) % lbItems.length];
        if (nb && nb.tagName === 'IMG') nb.loading = 'eager';
      });
      if (counter) counter.textContent = (currentIdx + 1) + ' / ' + lbItems.length;
    }
    root.querySelectorAll('[data-lightbox-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        // map από media-index (μπορεί να έχει κενά αν υπάρχει 3D model) σε θέση item
        var want = btn.getAttribute('data-index');
        var at = 0;
        for (var k = 0; k < lbItems.length; k++) {
          if (lbItems[k].getAttribute('data-index') === want) { at = k; break; }
        }
        showLightboxItem(at);
        lightbox.showModal();
      });
    });
    var prev = lightbox.querySelector('[data-lightbox-prev]');
    var next = lightbox.querySelector('[data-lightbox-next]');
    if (prev) prev.addEventListener('click', function () { showLightboxItem(currentIdx - 1); });
    if (next) next.addEventListener('click', function () { showLightboxItem(currentIdx + 1); });
    var lbClose = lightbox.querySelector('[data-lightbox-close]');
    if (lbClose) lbClose.addEventListener('click', function () { lightbox.close(); });
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox || e.target.classList.contains('pdp-lightbox__stage')) lightbox.close();
    });
    lightbox.addEventListener('close', function () { lbItems.forEach(pauseLightboxMedia); });
    // F3: play badge — κλικ = αναπαραγωγή· sync με play/pause (capture: δεν κάνουν bubble)
    lightbox.querySelectorAll('[data-lightbox-play]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = btn.parentElement.querySelector('video');
        if (v) v.play();
      });
    });
    lightbox.addEventListener('play', function (e) {
      if (e.target.tagName !== 'VIDEO') return;
      var wrap = e.target.closest('.pdp-lightbox__video');
      var badge = wrap && wrap.querySelector('[data-lightbox-play]');
      if (badge) badge.hidden = true;
    }, true);
    lightbox.addEventListener('pause', function (e) {
      if (e.target.tagName !== 'VIDEO') return;
      var wrap = e.target.closest('.pdp-lightbox__video');
      var badge = wrap && wrap.querySelector('[data-lightbox-play]');
      if (badge) badge.hidden = false;
    }, true);
    document.addEventListener('keydown', function (e) {
      if (!lightbox.open) return;
      if (e.key === 'ArrowLeft') showLightboxItem(currentIdx - 1);
      if (e.key === 'ArrowRight') showLightboxItem(currentIdx + 1);
    });
  }

  // «Αγορά τώρα» — instantBuy parity.
  // ΙΝCIDENT-FIX Σ07-12 (order 80€+χάραγμα πληρώθηκε χωρίς το 8€ fee): το παλιό
  // handler έκανε ΔΙΚΟ του /cart/add.js + redirect /checkout, παρακάμπτοντας το
  // pipeline του cart.js (fee χαράγματος + πέτρα μονόπετρου). Τώρα υποβάλλει τη
  // φόρμα στο ΙΔΙΟ pipeline (stone fail-closed → προϊόν → fee) και το cart.js
  // κάνει redirect στο /checkout αντί να ανοίξει drawer (__instantCheckout).
  var buyNow = root.querySelector('[data-buy-now]');
  if (buyNow && form) {
    buyNow.addEventListener('click', function () {
      buyNow.disabled = true;
      window.__instantCheckout = true;
      if (form.requestSubmit) {
        form.requestSubmit();
      } else {
        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
    });
  }

  // Ask an expert dialog
  var askDialog = document.querySelector('[data-ask-expert]');
  if (askDialog) {
    document.querySelectorAll('[data-ask-expert-open]').forEach(function (btn) {
      btn.addEventListener('click', function () { askDialog.showModal(); });
    });
    var askClose = askDialog.querySelector('[data-ask-expert-close]');
    if (askClose) askClose.addEventListener('click', function () { askDialog.close(); });
    askDialog.addEventListener('click', function (e) { if (e.target === askDialog) askDialog.close(); });
  }
})();
